<template>
    <div class="modal-dialog" role="document">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'ModalDialog'

};
</script>
